import React from "react";
import { Steps as AntdSteps, Grid } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentPageId, selectAllPages } from "reducers";
import { selectQnaIsLocked, sessionEdited } from "reducers/formSlice";

const { useBreakpoint } = Grid;
const verticalStyle = {
	minWidth: 200,
	maxWidth: 200,
	margin: "0 0 15px 0",
};
const horizontalStyle = {
	margin: "0 0 15px 0",
};

const Steps = ({ responsive = false }) => {
	const dispatch = useDispatch();
	const isLocked = useSelector(selectQnaIsLocked);
	const currentPageId = useSelector(selectCurrentPageId);
	const pages = useSelector(selectAllPages);
	const screens = useBreakpoint();

	//antd steps work by index not Ids, so need to find the index
	//of the current page
	const current = pages.findIndex((p) => p.id === currentPageId);
	const onChange = (current) => {
		const pageId = pages[current].id;
		dispatch(sessionEdited({ currentPage: pageId }));
	};
	const style = screens.md ? verticalStyle : horizontalStyle;
	const otherProps = responsive
		? {
				direction: screens.md ? "vertical" : "horizontal",
				labelPlacement: screens.md ? "horizontal" : "vertical",
				size: screens.md ? "default" : "small",
		  }
		: {
				direction: "horizontal",
				labelPlacement: "vertical",
				size: screens.md ? "default" : "small",
		  };

	const items = pages.map((p) => ({ title: p.title }));

	return (
		<div className="steps-container">
			<AntdSteps
				current={current}
				{...otherProps}
				style={style}
				onChange={isLocked ? onChange : null}
				items={items}
			/>
		</div>
	);
};

export default Steps;
